import React, { useState } from "react";
import "../../Assets/css/Queue.css";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { MdCheckBox } from "react-icons/md";
import { Button, Modal } from "react-bootstrap";
import useCountdown from "../../Hooks/useCountdown";
import { useLoader } from "../../context/LoaderContext";
import axiosUserInstance from "../../axiosUserInstance";
import BellIcon from "../../Assets/gif/Queue_BellIconLottie.gif";
import { handleDownload, hexToRgba } from "../../utils/common";
import { API_BASE_URL } from "../../utils/constant";
import Celebration from "../../Assets/photo/celebration.jpg";
import LoadingImage from "../Common/LoadingImage";
import LoadingVideo from "../Common/LoadingVideo";

const Queue = ({ userData }) => {
  const { setLoading } = useLoader();
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showAccountCreated, setShowAccountCreated] = useState(false);
  const [showAccountCreatedMessage, setShowAccountCreatedMessage] =
    useState(false);
  const validateEmail = (mail) => {
    return /^\S+@\S+\.\S+$/.test(mail); // simple email regex
  };

  const handleContinue = async () => {
    try {
      let valid = true;

      // Reset errors
      setEmailError("");
      setPasswordError("");

      // Email required
      if (!email) {
        setEmailError("Email is required");
        valid = false;
      } else if (!validateEmail(email)) {
        setEmailError("Enter a valid email");
        valid = false;
      }

      // Password required
      if (!password) {
        setPasswordError("Password is required");
        valid = false;
      } else if (password.length < 6) {
        setPasswordError("Password must be at least 6 characters.");
        valid = false;
      }

      if (!valid) return;

      const payload = {
        email,
        password,
        userId: userData.id,
      };
      setLoading(true);
      const response = await axiosUserInstance.post(
        `/user/add-follower`,
        payload
      );
      if (response.data) {
        if (response.data?.isNewAccount) {
          setShowAccountCreated(true);
          setTimeout(() => {
            setShowAccountCreatedMessage(true);
          }, 2000);
        } else {
          toast.success(response.data.message);
          handleClose();
        }
      } else {
        const apiError =
          response?.data?.message || "An error occurred. Please try again.";
        toast.error(apiError);
      }
    } catch (error) {
      const apiError =
        error?.response?.data?.message ||
        error?.message ||
        "An error occurred. Please try again.";
      toast.error(apiError);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setShow(false);
    setEmail("");
    setPassword("");
    setShowAccountCreated(false);
    setShowAccountCreatedMessage(false);
  };

  return (
    <div className="queue-widget">
      {userData?.userWidget?.queue?.length > 0 &&
        userData?.userWidget?.queue?.map((item, index) => (
          <QueueList
            item={item}
            setShow={setShow}
            key={index}
            userData={userData}
          />
        ))}
      {/* {!expired && (
        <div
          className="countdown-wrap"
          style={{ backgroundColor: "#f4f969ff" }}
        >
          <button className="bell-icon-btn" onClick={() => setShow(true)}>
            <img src={BellIcon} alt="bell" />
          </button>
          <h4>Blog Release</h4>
          <div className="countdown-time d-flex justify-content-center gap-3">
            <div>
              <h6>{days}</h6>
              <p>Days</p>
            </div>
            <div>
              <h6>{hours}</h6>
              <p>Hours</p>
            </div>
            <div>
              <h6>{minutes}</h6>
              <p>Minutes</p>
            </div>
            <div>
              <h6>{seconds}</h6>
              <p>Seconds</p>
            </div>
          </div>
        </div>
      )} */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        backdrop="static"
        keyboard={false}
        style={{ zIndex: 9999 }}
      >
        <Modal.Body className="p-0 text-center">
          {/* Close button (top-right overlay) */}
          <Button
            variant="light"
            onClick={handleClose}
            style={{
              position: "absolute",
              top: "-18px",
              right: "-18px",
              borderRadius: "50%",
              padding: "4px 8px",
            }}
          >
            ✕
          </Button>

          <div className="create-account-form">
            {showAccountCreated ? (
              showAccountCreatedMessage ? (
                <>
                  <LoadingImage
                    src={Celebration}
                    alt="celebration"
                    width="100px"
                    height="100px"
                    skeletonHeight="100px"
                    style={{ width: "100px", height: "100px" }}
                  />
                  <p>
                    Success! sit tight, you will receive a notification in your
                    inbox when {userData?.username || userData?.userName || ""}{" "}
                    drops this!
                  </p>
                  <Button
                    className="w-100 bg-dark"
                    style={{ borderRadius: "40px" }}
                    onClick={handleClose}
                  >
                    Back
                  </Button>
                  <Link to="/auth/login" className="d-block mt-2 text-dark">
                    LogIn Page
                  </Link>
                </>
              ) : (
                <div
                  className="d-flex flex-column align-items-center justify-content-center"
                  style={{ height: "300px" }}
                >
                  <h4>Account Created!</h4>
                  <MdCheckBox size={100} color="#47a547" />
                </div>
              )
            ) : (
              <>
                <div className="bell-icon">
                  <LoadingImage src={BellIcon} alt="bell" />
                </div>
                <p className="mb-0">
                  To get notifications from{" "}
                  {userData?.username || userData?.userName || ""} when the
                  countdown ends,
                </p>
                <p className="mb-0">
                  Please create an account with an email you want to be notified
                  to
                </p>

                <div className="text-start w-100">
                  <label>Email</label>
                  <input
                    type="email"
                    className="form-control mb-2"
                    placeholder="Enter email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />

                  {emailError && (
                    <p className="text-danger small">{emailError}</p>
                  )}

                  <label>Password</label>
                  <input
                    type="password"
                    className="form-control mb-2"
                    placeholder="Enter password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />

                  {passwordError && (
                    <p className="text-danger small">{passwordError}</p>
                  )}
                </div>

                <Button className="w-100 mt-2" onClick={handleContinue}>
                  Continue
                </Button>
                <p className="mb-0">
                  You may then use the registered credentials to log in BioME in
                  the future
                </p>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

const QueueList = ({ item, setShow, userData }) => {
  const { days, hours, minutes, seconds, expired } = useCountdown(
    item?.releaseAt || ""
  );

  return expired ? (
    <div
      className="bg-white shadow-sm mb-2 p-3"
      style={{ borderRadius: "8px" }}
    >
      <h4 className="text-center">New Release, See it Now!</h4>
      {item?.thumbnail && (
        <div className="object-fit-content">
          {item?.thumbnailType === "video" ? (
            <LoadingVideo
              src={item?.thumbnail}
              type="video/mp4"
              alt="Released Content"
              className="object-fit"
              controls
              width="100%"
              height="auto"
              skeletonHeight="250px"
            />
          ) : (
            <LoadingImage
              src={item?.thumbnail}
              alt="Released Content"
              className="object-fit"
              width="100%"
              height="auto"
              skeletonHeight="250px"
            />
          )}
        </div>
      )}
      <p className="mb-0 mt-2" style={{ fontSize: "14px" }}>
        {item?.description}
      </p>
      {item?.type === "link" && item?.link && (
        <button
          className="mt-2 btn btn-primary w-100 bg-dark"
          style={{ maxWidth: "300px", borderRadius: "24px" }}
          onClick={() => {
            window.open(item?.link, "_blank", "noopener,noreferrer");
          }}
        >
          Go to Link
        </button>
      )}
      {item?.type === "files" && item?.fileLink && (
        <button
          className="mt-2 btn btn-primary w-100 bg-dark"
          style={{ maxWidth: "300px", borderRadius: "24px" }}
          onClick={() =>
            handleDownload(
              `${API_BASE_URL}/download-file?url=${encodeURIComponent(
                item?.fileLink
              )}`
            )
          }
        >
          Download
        </button>
      )}
    </div>
  ) : (
    <div
      className="countdown-wrap mb-2"
      style={{
        backgroundColor: hexToRgba(
          item?.containerColor || "#f4f969ff",
          item?.containerOpacity || 1
        ),
        color: item?.textColor || "#000000ff",
        borderWidth: item?.borderWidth || 0,
        borderColor: item?.borderColor || "transparent",
        borderStyle: "solid",
        borderRadius: `${userData?.pageTheme?.backgroundRadius}px`,
      }}
    >
      <button className="bell-icon-btn" onClick={() => setShow(true)}>
        <LoadingImage src={BellIcon} alt="bell" />
      </button>
      <h4 style={{ fontFamily: userData?.pageTheme?.pageFont }}>
        {item?.title}
      </h4>
      <div className="countdown-time d-flex justify-content-center gap-3">
        <div>
          <h6 style={{ fontFamily: userData?.pageTheme?.pageFont }}>{days}</h6>
          <p style={{ fontFamily: userData?.pageTheme?.pageFont }}>Days</p>
        </div>
        <div>
          <h6 style={{ fontFamily: userData?.pageTheme?.pageFont }}>{hours}</h6>
          <p style={{ fontFamily: userData?.pageTheme?.pageFont }}>Hours</p>
        </div>
        <div>
          <h6 style={{ fontFamily: userData?.pageTheme?.pageFont }}>
            {minutes}
          </h6>
          <p style={{ fontFamily: userData?.pageTheme?.pageFont }}>Minutes</p>
        </div>
        <div>
          <h6 style={{ fontFamily: userData?.pageTheme?.pageFont }}>
            {seconds}
          </h6>
          <p style={{ fontFamily: userData?.pageTheme?.pageFont }}>Seconds</p>
        </div>
      </div>
    </div>
  );
};

export default Queue;
